import { render, staticRenderFns } from "./DocumentTracker.vue?vue&type=template&id=d3128a66&"
import script from "./DocumentTracker.vue?vue&type=script&lang=js&"
export * from "./DocumentTracker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTracker.vue?vue&type=style&index=0&id=d3128a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports